import {
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from 'recharts'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../../constants/common'
import {
  CHART_DEFAULT_DATA_KEY,
  CHART_DEFAULT_NAME_KEY,
  CHART_RESPONSIVE_CONTAINER_PROPS,
  PIE_CHART_COLORS,
} from '../Chart.constants'
import {
  getChartItemColor,
  renderChartLegendText,
  renderChartPieActiveSector,
} from '../Chart.utils'

import {
  PIE_CHART_DEFAULT_PROPS,
  PIE_DEFAULT_PROPS,
  PIE_LEGEND_DEFAULT_PROPS,
} from './ChartPie.constants'

function ChartPie({
  activeShape = renderChartPieActiveSector,
  chartProps = PIE_CHART_DEFAULT_PROPS,
  colors = PIE_CHART_COLORS,
  data = EMPTY_LIST,
  dataKey = CHART_DEFAULT_DATA_KEY,
  legendProps = PIE_LEGEND_DEFAULT_PROPS,
  nameKey = CHART_DEFAULT_NAME_KEY,
  pieProps = PIE_DEFAULT_PROPS,
  tooltipProps = EMPTY_OBJECT,
}) {
  return (
    <ResponsiveContainer {...CHART_RESPONSIVE_CONTAINER_PROPS}>
      <PieChart {...chartProps}>
        <Pie
          {...pieProps}
          activeShape={activeShape}
          data={data}
          dataKey={dataKey}
          nameKey={nameKey}
        >
          {data.map((item, index) => (
            <Cell
              fill={getChartItemColor({ colors, index, item })}
              key={item.id ?? item[nameKey]}
            />
          ))}
        </Pie>
        {tooltipProps ? <Tooltip {...tooltipProps} /> : null}
        {legendProps ? (
          <Legend
            {...legendProps}
            formatter={legendProps.formatter ?? renderChartLegendText}
          />
        ) : null}
      </PieChart>
    </ResponsiveContainer>
  )
}

export default ChartPie
